import React, { useState, useContext } from 'react'
import ApplicationForm from '../sections/ApplicationForm'
import { Box } from '@mui/material'
import ZoneSelection from '../sections/ZoneSelection'
import DesignationSelection from '../sections/DesignationSelection'
import { Routes, Route, Navigate } from 'react-router'
import { v4 as uuidv4 } from 'uuid'
import Turnstile, { useTurnstile } from 'react-turnstile'
import { CaptchaTokenContext } from '../context/CaptchaContext'
import Success from '../sections/Success'
import { usePageViewTracking } from '../hooks/useAnalytics'

export const MainNavigator = () => {
  const [renderContent, setRenderContent] = useState(false)
  const { setToken, setUuid, isFormCompleted } = useContext(CaptchaTokenContext)

  const turnstile = useTurnstile()
  usePageViewTracking()

  return (
    <>
      {!renderContent && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
          <Turnstile
            theme='light'
            sitekey='0x4AAAAAABjL_1WUNvL4vNJJ' // Test site key - always pass -   '1x00000000000000000000AA'
            onVerify={(token) => {
              console.log('Turnstile token:', token)
              setToken(token)
              setUuid(uuidv4())
              setRenderContent(true)
            }}
            onExpire={() => {
              console.log('Turnstile token expired')
              turnstile.reset()
              setToken('')
              setUuid('')
              setRenderContent(false)
            }}
          />
        </Box>
      )}
      {
        renderContent && (
          isFormCompleted
            ? (
              <Routes>
                <Route path='/success' element={<Success />} />
                <Route path='*' element={<Navigate to='/success' replace />} />
              </Routes>
              )
            : (
              <Routes>
                <Route path='/' element={<ZoneSelection />} />
                <Route path='/:zone' element={<DesignationSelection />} />
                <Route path='/apply/:zone/:designation' element={<ApplicationForm />} />
              </Routes>
              )
        )
}
    </>
  )
}

export default MainNavigator
